import { batch, useDispatch, useSelector } from "react-redux"
import { getUserCookieSettings } from "app/modules/analytics/redux/analyticsSelectors"
import { ChangeEvent, SyntheticEvent, useState } from "react";
import { hidePopup } from "app/actions/AppActions";
import { UserCookieSettings } from "app/modules/analytics/analyticsTypes";
import { closeIcon } from 'app/constants/IconsConstants';
import { Checkbox } from "app/ui/Checkbox";
import { getWithNewDesign } from "app/selectors/AppSelectors";
import { Switch } from "app/ui/Switch";
import { Button, ButtonType } from "app/ui/Button";
import { setUserCookieSettingsThunk } from "app/modules/analytics/redux/analyticsThunks";

const CookieSettingsPopup = () => {
	const dispatch = useDispatch();

	const { isAnalyticsCookieAllowed, isMarketingCookieAllowed } = useSelector(getUserCookieSettings);
	const withNewDesign = useSelector(getWithNewDesign);

	const [formData, setFormData] = useState<UserCookieSettings>({ isAnalyticsCookieAllowed, isMarketingCookieAllowed});

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const fieldName = event.currentTarget.name as keyof UserCookieSettings;
		const isChecked = event.target.checked;

		setFormData((prev) => ({
			...prev,
			[fieldName]: isChecked
		}))
	}

	const handleClose = () => {
		dispatch(hidePopup());
	}

	const handleSubmit = (event: SyntheticEvent) => {
		event.preventDefault();

		batch(() => {
			dispatch(setUserCookieSettingsThunk(formData));
			dispatch(hidePopup());
		})

		if (!formData.isAnalyticsCookieAllowed) location.reload();
	}

	const CheckboxComponent = withNewDesign ? Switch : Checkbox;

	return (
		<form className="cookie-settings-popup" onSubmit={handleSubmit}>
			<div className="cookie-settings-popup__header">
				<span className="cookie-settings-popup__header-title text--bold">{i18n.t("CookieUsage")}</span>
				<button className="cookie-settings-popup__header-close-icon" onClick={handleClose}>{closeIcon}</button>
			</div>
			<div className="cookie-settings-popup__item">
				<CheckboxComponent isActive isDisabled onChange={_.noop}/>
				<div className="cookie-settings-popup__item-title">
					<label>{i18n.t("TechnicalCookies")}</label>
					<div className="cookie-settings-popup__item-title-badge">{i18n.t("Required")}</div>
				</div>
				<span className="cookie-settings-popup__item-description">
					{i18n.t("TechnicalDescription")}
				</span>
			</div>
			<div className="cookie-settings-popup__item">
				<CheckboxComponent name="isAnalyticsCookieAllowed" id="analytics" isActive={!!formData.isAnalyticsCookieAllowed} onChange={handleChange}/>
				<label className="cookie-settings-popup__item-title" htmlFor="analytics">{i18n.t("AnalyticalCookies")}</label>
				<span className="cookie-settings-popup__item-description">
					{i18n.t("AnalyticalDescription")}
				</span>
			</div>
			<div className="cookie-settings-popup__item">
				<CheckboxComponent name="isMarketingCookieAllowed" id="marketing" isActive={!!formData.isMarketingCookieAllowed} onChange={handleChange}/>
				<label className="cookie-settings-popup__item-title" htmlFor="marketing">{i18n.t("MarketingCookies")}</label>
				<span className="cookie-settings-popup__item-description">
					{i18n.t("MarketingDescription")}
				</span>
			</div>
			<div className="cookie-buttons-container">
				<Button classPrefix="cookie-" onClick={handleClose}>{i18n.t("CancelChanges")}</Button>
				<Button classPrefix="cookie-" kind={ButtonType.PRIMARY} type="submit">{i18n.t("SaveChanges")} </Button>
			</div>
		</form>
	)
}

export default CookieSettingsPopup;